<!--suppress ALL -->
<template>
  <l-layout :layout="['xs12']" bottom-space>
    <l-data-table
      v-if="!loading"
      :filter-items="filterItems"
      @click:row="getDetails($event.item)"
      :get-data-func="getLetterReservations"
      :headers="letterReservationHeader"
      clickable
      init-sort-by="name"
      ref="letterReservationList"
      title-text="函件预约申请列表"
      hide-title-search
    >
<!--      <template slot="title-action">
        <l-option-menu
          :options="moreActions"
          @delete="deleteUser(selected)"
        >
          <v-btn icon slot="activator">
            <v-icon>$vuetify.icons.more</v-icon>
          </v-btn>
        </l-option-menu>
      </template>-->
      <template slot="row-action" slot-scope="{item}">
        <td @click.stop class="px-0 mx-0 text-xs-center">
<!--          <l-option-menu
            :options="moreActions"
            @cancel="cancelReservation(item)"
            @edit="editReservation(item)"
            @delete="deleteReservation(item)"
            @comment="getCommentList(item)"
            @add="appendReservation(item)"
          >
            <v-btn icon slot="activator">
              <v-icon>$vuetify.icons.more</v-icon>
            </v-btn>
          </l-option-menu>-->
          <v-menu  left>
            <v-btn slot="activator" icon small>
              <v-icon  small>$vuetify.icons.more</v-icon>
            </v-btn>
            <v-list dense>
              <v-list-tile @click="editReservation(item)" :disabled="item.reviewStatus+''!=='1'&&item.reviewStatus+''!=='3'&&item.reviewStatus+''!=='4'">
                <v-list-tile-title class="pr-1">
                  编辑申请
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="cancelReservation(item)" :disabled="item.reviewStatus+''!=='2'&&item.reviewStatus+''!=='5'">
                <v-list-tile-title class="pr-1">
                  撤销申请
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="deleteReservation(item)" :disabled="item.reviewStatus+''!=='1'&&item.reviewStatus+''!=='3'&&item.reviewStatus+''!=='4'">
                <v-list-tile-title class="pr-1">
                  删除申请
                </v-list-tile-title>
              </v-list-tile>

              <v-list-tile  @click="appendReservation(item)" :disabled="item.reviewStatus+''!=='6'">
                <v-list-tile-title class="pr-1">
                  追加申请
                </v-list-tile-title>
              </v-list-tile>
              <!--:disabled="props.item.reviewStatus!='6'"-->
              <v-list-tile @click="getCommentList(item)">
                <v-list-tile-title class="pr-1">
                  查看附言
                </v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </td>
      </template>
    </l-data-table>
    <l-fixed-btn
      v-if="!loading"
      @click="createReservation()"
      icon="$vuetify.icons.add"
    ></l-fixed-btn>
    <v-dialog
      v-model="commentDialog"
      width="500">
      <v-layout column>
        <v-card>
          <v-card-title>
            <span>函件预约附言</span>
            <v-spacer></v-spacer>
          <!--  <v-btn icon @click="commentDialog=false">
              <v-icon>close</v-icon>
            </v-btn>-->
          </v-card-title>
          <v-card-text class="pa-0">
            <div v-if="commentList.length===0">
              <v-divider></v-divider>
              <v-layout justify-center class="ma-2">
                <span class="error--text">暂无记录</span>
              </v-layout>
            </div>
            <div v-else>
              <v-layout column>
                <v-layout v-for="(item,index) in commentList"  :key="index" column>
                  <v-divider></v-divider>
                  <div style="text-align: left" v-if="index%2===0" class="pa-2">
                    <p>{{item.createdBy}}</p>
                  <!--  <p>{{time.stringify(item.createdTime)}}</p>-->
                    <p>{{item.content}}</p>
                  </div>
                  <div style="text-align: right" v-else class="pa-2">
                    <p>{{item.createdBy}}</p>
                 <!--   <p>{{time.stringify(item.createdTime)}}</p>-->
                    <p>{{item.content}}</p>
                  </div>
                </v-layout>
              </v-layout>
            </div>
          </v-card-text>
        </v-card>
      </v-layout>
    </v-dialog>
    <v-layout class="my-5" justify-center v-if="loading">
      <v-progress-circular color="primary" indeterminate size="60"></v-progress-circular>
    </v-layout>
  </l-layout>
</template>
<script>
import {time} from '../../../ladmin/utils/time'
import {ReservationAuthority} from '../../../object'
  function reviewStatusTrans(v){
    switch (v+'') {
      case '1':return '创建未提交';
      case '2':return '首次提交待审核';
      case '3':return '退回返修';
      case '4':return '返修更新未提交';
      case '5':return '返修提交待审核';
      case '6':return '审核通过';
      case '7':return '审核拒绝';
      default:return v;
    }
  }
  export default{
    name:'LetterReservationList',
    data:()=>({
      letterReservationHeader:[
        {
          text:'审核状态',
          align:'left',
          value:'reviewStatus',
          placeholder:'N/A',
          f:v=>reviewStatusTrans(v)
        },
        {
          text:'活动名称',
          align:'left',
          value:'obGrpName',
          placeholder:'N/A',
          f:v=>(v==='null')?'N/A':v
        },
        {
          text:'申请者姓名',
          align:'left',
          value:'applName',
          placeholder:'N/A'
        },
        {
          text:'申请类型',
          align:'left',
          value:'rootProcInst',
          placeholder:'N/A',
          f:v=>(v===true)?'首次申请':'追加申请'
        },
        {
          text:'申请时间',
          align:'left',
          value:'obGrpCreateTime',
          placeholder:'N/A',
          f:v=>time.stringify(v)
        },
        {text: '', value: '', align: 'right', width: '80px', sortable: false}
      ],
      filterItems:[
        {
          prependIcon: '',
          key: 'reviewStatus',
          value: '',
          label: '查询类型',
          type: 'select',
          items:[{
            value:'0',
            text:'全部申请'
            },
            {
              value:'2',
              text:'提交审核'
            },
            {
              value:'3',
              text:'退回返修'
            },
            {
              value:'4',
              text:'审核通过'
            },
            {
              value:'5',
              text:'审核拒绝'
            }],
          itemValue:'value',
          itemText:'text',
          layout: ['xs12', 'sm4'],
        },
      ],
      loading:false,
      commentDialog:false,
      commentList:[],
      moreActions:[
        {
          event:'edit',
          label:'编辑申请',
          icon:''
        },
        {
          event:'cancel',
          label:'撤销申请',
          icon:'',
        },
        {
          event:'delete',
          label:'删除申请',
          icon:''
        },
        {
          event:'add',
          label:'追加申请',
          icon:''
        },
        {
          event:'comment',
          label:'查看附言',
          icon:''
        }
      ],
    }),
    methods:{
      /*获取函件预约申请列表*/
      async getLetterReservations({pagination, sortStack, filterItems, search}){
          let res = await this.$store.dispatch('letterReservation/getLetterReservations',{
            pagination,sortStack,filter:filterItems[0].value,search
          });
          if(res.data.code+''==='200')
          {
            //console.log(res)
            return {items:res.data.data.content,amount:res.data.data.totalSize};
          }
          else
          {
            this.$L.alert('error',{message:'查询函件预约数据失败'})
          }
      },
      /*获取已部署流程*/
      async getDeployedProcess(){
        this.loading=true;
        let res = await this.$store.dispatch('letterReservation/getDeployedProcess');
        this.loading=false;
        if(res.data.code+''==='200')
        {
          sessionStorage.setItem('processId',res.data.data[0].id);
          this.$L.alert('success',{message:'查询成功'})
        }
        else
        {
          this.$L.alert('error',{message:'查询部署流程失败'})
        }
      },
      /*用户点击列表获取到函件预约详细信息*/
      getDetails(item){
        console.log(item);
        let selectionString = document.getSelection().toString();
        if(!selectionString)
        {
          if(item.reviewStatus+''==='1'||item.reviewStatus+''==='3'||item.reviewStatus+''==='4')
          {
            this.editReservation(item);
          }
          else
          {
            this.readReservation(item);
          }
        }
      },
      /*创建新的函件预约*/
      async createReservation(){
        let config={
          "procdefId":sessionStorage.getItem('processId'),
          "initiator":this.getUserInfo().id,
          "groups":[
            "user"
          ]
        }
        let res = await this.$store.dispatch('letterReservation/createReservation',config)
        if(res.data.code+''==='200'){
          let item = {
            id:res.data.data[0].processInstanceId,
            obGrpName:"null",
            rootProcInst:true
          }
          this.editReservation(item)
        }else{
          this.$L.alert('error',{message:res.data.msg})
        }
      },
      /*追加预约*/
      async appendReservation(item){
        if(item.reviewStatus+''!='6'){
          this.$L.alert('error',{message:'预约未通过无法追加预约'})
          return
        }
        let config={
          "procdefId":sessionStorage.getItem('processId'),
          "initiator":this.getUserInfo().id,
          "obGrpId":item.obGrpId,
          "parentProcInstId":item.id,
          "groups":[
            "user"
          ]
        }
        let res = await this.$store.dispatch('letterReservation/appendReservation',config)
        if(res.data.code+''==='200'){
          let item = {
            id:res.data.data.processInstanceId,
            obGrpName:"N/A",
            rootProcInst:false
          }
          this.editReservation(item)
        }else{
          this.$L.alert('error',{message:'创建失败，原因：'+res.data.msg})
        }
      },
      /*编辑函件预约*/
      async editReservation(item){
       /* let config = {
          "assignee":this.getUserInfo().id,
          "procInstId":item.id,
          "groups":[
            "user"
          ]
        }
        let res = await this.$store.dispatch('letterReservation/editReservation',config);
        if(res.data.code+''==='200'){
          let taskConfig = res.data.data[0];
          this.$router.push({
            name:'reservationDetails',
            params:{taskConfig:taskConfig,status:'edit',obGrpName:item.obGrpName},
            query:{id:item.id}})
        }else{
          this.$L.alert('error',{message:'查询任务失败'});
        }*/
        let label = (item.obGrpName==='null')?'N/A':item.obGrpName
        this.$router.push({
          name:'reservationDetails',
          path:'/letterReservationList/reservationDetails',
          query:{id:item.id,status:'edit',obGrpName:label,reservationType:(item.rootProcInst===true)?"common":"add"}})
      },
      /*撤销函件预约*/
      async cancelReservation(item){
        let res = await this.$store.dispatch('letterReservation/cancelReservation',item.id)
        if(res.data.code+''==='200'){
          this.$L.alert('success',{message:'撤销成功'})
          this.$refs.letterReservationList.refresh()
        }else{
          this.$L.alert('error',{message:res.data.msg})
        }
      },
      /*删除函件预约*/
      async deleteReservation(item){
        let {res,close} = await this.$L.confirm({title:'提示',text:'您确定要删除该函件预约？'})
        if(res){
          try {
            let res = await this.$store.dispatch('letterReservation/deleteReservation_user',item.id)
            if(res.data.code+''==='200'){
              this.$L.alert('success',{message:'删除成功'})
              this.$refs.letterReservationList.refresh()
            }else{
              this.$L.alert('error',{message:'删除失败，原因：'+res.data.msg})
            }
          }catch (e) {
            this.$L.alert('error', e.message)
          }
        }
        close()
      },
      /*只读函件预约信息*/
      async readReservation(item){
        let label = (item.obGrpName==='null')?'N/A':item.obGrpName
        this.$router.push({
          name:'reservationDetails',
          path:'/letterReservationList/reservationDetails',
          query:{id:item.id,status:'read',obGrpName:label,reservationType:(item.rootProcInst===true)?"common":"add"}})
      },
      /*从session获取登录用户信息*/
      getUserInfo(){
        let loginInfo = sessionStorage.getItem('loginInfo');
        loginInfo = eval('('+loginInfo+')');
        return loginInfo
      },
      /*获取用户的uuid*/
      async getUserId(){
        let res = await this.$store.dispatch('letterReservation/getUserInfo',this.getUserInfo().id)
        if(res.data.status===1){
          sessionStorage.setItem('userId',res.data.data.content[0].id)
        }else{
          this.$L.alert('error',{message:res.data.msg})
        }
      },
      /*获取到函件预约附言信息*/
      async getCommentList(item){
        this.commentDialog=true
        let res = await this.$store.dispatch('letterReservation/getCommentList',item.id)
        if(res.data.code+''==='200'){
          if(res.data.data!=null)
            this.commentList=res.data.data;
        }else{
          this.$L.alert('error',{message:'查询附言失败，原因：'+res.data.msg})
        }
      },
      async getReservationConfig () {
        let res = await this.$store.dispatch('reservationConfig/getReservationConfig', 'order_letter')
        console.log(res.data.data)
        if (res.data.status === 1) {
          let object = new ReservationAuthority({
            name: '函件预约',
            maxVehicleAmount: 1000,
            maxStartDay: res.data.data.maxAdvDays,
            maxDurationDay: res.data.data.maxDurDays,
            presetCtrls: res.data.data.presetCtrls})
          // console.log(object)
          this.$store.commit('reservation/setLetterAuth', object)
        }
        else {
          this.$L.alert('error', {message: '查询预约配置失败，原因：' + res.data.msg})
        }
      }
    },
    created(){
      this.getDeployedProcess()
      this.getReservationConfig()
      //this.getUserId()
    },
  }
</script>
